import { Dispatch, SetStateAction, useState } from "react";
import { ChatBox } from "./components/chat-box";
import { Ligacao } from "./components/ligacao";
import { Email } from "./components/email";
// import checkConnection from '../../../assets/icons/check.svg'
import { ChatNotConnect } from "./components/chat-not-connect";

interface ChatProps {
  isOpen: boolean;
  closeSidebar: Dispatch<SetStateAction<boolean>>;
}

export const Chat = ({ isOpen, closeSidebar }: ChatProps) => {
  const [chat, setChat] = useState("WhatsApp");
  return (
    <div
      className={`z-50 fixed bottom-0 right-0  h-chatBar w-[20vw] border bg-white  py-2  text-gray-800  duration-300 ease-in-out ${isOpen ? "translate-x-0 " : "translate-x-full"
        }`}
    >
      <div className="mb-4 mt-8 grid w-full grid-cols-4 gap-1 px-2 text-xs">
        <button
          className={`${chat === "WhatsApp"
            ? "bg-green-600 text-white"
            : "bg-white text-gray-800  "
            } my-2 rounded px-2 py-2 text-center font-medium flex items-center justify-evenly`}
          onClick={() => setChat("WhatsApp")}
        >

          WhatsApp
        </button>
        <button
          className={`${chat === "SMS" ? "bg-red-600 text-white border-2 border-red-600"
            : "bg-white text-gray-800  "
            } rounded px-2 py-2 text-center font-medium my-2 disabled:opacity-20 hover:disabled:opacity-20`}
          onClick={() => setChat("SMS")}
          disabled
        >
          SMS
        </button>
        <button
          className={`${chat === "Ligação"
            ? "bg-green-600 text-white "
            : "bg-white text-gray-800 "
            } rounded px-2 py-2 text-center font-medium my-2`}
          onClick={() => setChat("Ligação")}
        >
          Ligação
        </button>
        <button
          className={`${chat === "E-mail"
            ? "bg-green-600 text-white "
            : "bg-white text-gray-800  "
            } rounded px-2 py-2 text-center font-medium m-2`}
          onClick={() => setChat("E-mail")}
        >
          E-mail
        </button>
      </div>
      <button
        className="absolute right-2 top-2 border-0 bg-transparent text-primary"
        onClick={() => closeSidebar(false)}
      >
        <svg
          aria-hidden="true"
          className="h-6 w-6"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
            clipRule="evenodd"
          ></path>
        </svg>
      </button>

      <div className="flex h-full w-full items-center justify-center ">
        {chat === "WhatsApp" && <ChatBox type="whatsapp" />}
        {/* {chat === "SMS" && <ChatBox type="sms" />} */}
        {chat === "SMS" && <ChatNotConnect />}
        {chat === "Ligação" && <Ligacao />}
        {chat === "E-mail" && <Email />}
      </div>
    </div>
  );
};
